import { Action, createAction } from '@reduxjs/toolkit';
import * as actionTypes from './actionTypes';

export const setModal = createAction<{
  field: FlattenKeys<ModalState>;
  value: any;
}>(actionTypes.SET_MODAL);

export const resetModal = createAction<void>(actionTypes.RESET_MODAL);

const modalActions = (dispatch: <T>(action: Action) => T) =>
  Object.assign(
    {},
    {
      setModal: <T extends FlattenKeys<ModalState>>(
        field: T,
        value: DeepType<ModalState, T>,
      ) => dispatch<void>(setModal({ field, value })),
      resetModal: () => dispatch<void>(resetModal()),
    },
  );

export default modalActions;
